/************************************
MODULE:         DROPDOWN CLASS
WHAT IT DOES:   Dropdown functionality
*************************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    }
    else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    }
    else { root.returnExports = factory(root.jQuery); }
}(this, function ($) {

    function dropdown(el, settings) {
        this.dropdown = el;

        $.extend(this, this._defaults);
        this.settings = $.extend({}, this._settings, this.dropdown.data(), typeof settings == 'undefined' ? {} : settings);

        this.init();
    }

    dropdown.prototype._settings = {
        link: null,
        content: null,
        clickCallback: null,
        animationCallback: null,
        erase: false,
        time: 0.5,
        desktop: true,
        tabletSmall: true,
        tabletPortrait: true,
        mobile: true,
        collapseOnOuterClick: false
    }

    dropdown.prototype._defaults = {
        tween: null,
        dropdownLink: null,
        dropdownContent: null,
        isOpened: false,
        isInited: false,
        oneOf: ''
    }

    dropdown.prototype.init = function () {
        var dropdown = this.dropdown;
        this.dropdownLink = this.settings.link != null ? this.settings.link : dropdown.find('.js-dropdown-link').filter(function (index) {
            return $(this).parents('.js-dropdown').first().is(dropdown) ? true : false
        });
        this.dropdownContent = this.settings.content != null ? this.settings.content : dropdown.find('.js-dropdown-content').filter(function (index) {
            return $(this).parents('.js-dropdown').first().is(dropdown) ? true : false
        });

        if (!this.dropdownLink.length || !this.dropdownContent.length)
            return;

        this.isOpened = this.dropdown.hasClass('opened');

        var tweenmax = require('tweenmax');


        $(window).on('resize:finished', this.resize.bind(this));
        this.resize();
        if (this.settings.collapseOnOuterClick) {
            $(document).on('click', this.onDocumentClick.bind(this));
        }
    }

    dropdown.prototype.clickProcess = function (e) {
        if (typeof e != 'undefined' && typeof e.preventDefault == "function") {
            e.preventDefault();
        }
        var link = $(e.target),
            allowClose = true,
            dataLink;
        if (!link.is('a'))
            link = link.parents('a');

        dataLink = link.data();

        if (typeof dataLink != 'undefined' && typeof dataLink.openSubdropds != 'undefined' && dataLink.openSubdropds) {
            var childDropdowns = this.dropdownContent.find('.js-dropdown').not('.opened');
            if (childDropdowns.length) {
                allowClose = false;
                childDropdowns.trigger('dropdown:open');
            }
        }


        this[this.isOpened && !link.hasClass('js-only-open') && allowClose ? "close" : "open"]();

        if (this.settings.clickCallback != null)
            this.settings.clickCallback();

    }

    dropdown.prototype.open = function (e) {
        if (typeof e != 'undefined' && typeof e.stopPropagation == "function") {
            e.stopPropagation();
        }

        if (this.isOpened) {
            this.animationComplete();
            return;
        }

        if(this.settings.oneOf && window.App.globals.isMobileView) {
            $('.js-dropdown[data-one-of="' + this.settings.oneOf + '"]').trigger('dropdown:close');
        }

        var dropdownChildren = this.dropdownContent.children();
        if (!dropdownChildren.length)
            return;

        this.dropdown.addClass('animated');
        this.isOpened = true;

        this.dropdownContent.css({
            'max-height': 0,
            'overflow': 'hidden'
        });

        this.dropdown.addClass('opened');
        this.tweenPromote();
        this.tween = new TimelineMax({onComplete: this.animationComplete.bind(this)});
        this.tween.fromTo(this.dropdownContent, this.settings.time, { maxHeight: 0 }, { maxHeight: dropdownChildren.first().outerHeight() });
        this.tween.play();
    }

    dropdown.prototype.close = function (e) {
        if (typeof e != 'undefined' && typeof e.stopPropagation == "function") {
            e.stopPropagation();
        }
        if (!this.isOpened) {
            this.animationComplete();
            return;
        }

        this.dropdown.addClass('animated');
        this.isOpened = false;
        this.dropdownContent.css({
            'max-height': this.dropdownContent.children().first().outerHeight(),
            'overflow': 'hidden'
        });
        this.dropdown.removeClass('opened');
        this.tweenPromote();
        this.tween = new TimelineMax({onComplete: this.animationComplete.bind(this)});
        this.tween.to(this.dropdownContent, this.settings.time, { maxHeight: 0 });
        this.tween.play();
    }

    dropdown.prototype.animationComplete = function () {
        if (this.settings.erase) {
            this.dropdownContent.css({
                'max-height': '',
                'overflow': ''
            });
        } else {
            this.dropdownContent.css('max-height', this.isOpened ? 'none' : '0');
            this.dropdownContent.css('overflow', this.isOpened ? 'visible' : 'hidden');
        }

        this.dropdown.removeClass('animated');

        $(window).trigger('scroll:refresh');

        if (this.settings.animationCallback != null)
            this.settings.animationCallback();
    }

    dropdown.prototype.tweenPromote = function () {
        if (typeof this.tween == 'undefined' || this.tween == null)
            return;

        if (typeof this.tween.progress == 'function' && this.tween.progress() < 1) {
            this.tween.pause();
            this.tween.progress(1);
        }
        if (typeof this.tween.destroy == 'function') {
            this.tween.destroy();
        }
    }

    dropdown.prototype.bindEvents = function (isOn) {
        if(this.isInited == isOn) {
            return;
        }
        this.isInited = isOn;

        if(isOn) {
            this.dropdownLink.on('click.dropdown', this.clickProcess.bind(this));
            this.dropdown.on('dropdown:open', this.open.bind(this));
            this.dropdown.on('dropdown:close', this.close.bind(this));
        }
       else {
           this.dropdownLink.off('click.dropdown');
           this.dropdown.off('dropdown:open');
           this.dropdown.off('dropdown:close');

       }
    }

    dropdown.prototype.resize = function () {
        var isMobileOn = window.App.globals.isMobileView && window.App.globals.isMobileSmall && this.settings.mobile,
            isTabletPortaitOn = window.App.globals.isMobileView && !window.App.globals.isMobileSmall && this.settings.tabletPortrait,
            isTabletSmallOn = !window.App.globals.isMobileView && window.App.globals.isTabletSmall && this.settings.tabletSmall,
            isDesktopOn = !window.App.globals.isTabletSmall && this.settings.desktop,
            isOn = isMobileOn || isTabletPortaitOn || isTabletSmallOn || isDesktopOn;

        if(window.App.globals.isMobileView && this.settings.oneOf) {
            this.close();
        }

        this.bindEvents(isOn);

        if(!isOn) {
            this.dropdownContent.css({
                'max-height': '',
                'overflow': ''
            });
        }

        if(!isOn || this.settings.erase) {
            return;
        }

        this.dropdownContent.css({
            maxHeight: this.isOpened ? this.dropdownContent.children().first().outerHeight() : 0,
            overflow: this.isOpened ? 'none' : 'hidden'
        });
    }

    dropdown.prototype.onDocumentClick = function(e) {
        if (this.isOpened && !this.dropdown[0].contains(e.target)) {
            this.close();
        }
    };

    return dropdown;

}));



/*****************
 ** WEBPACK FOOTER
 ** ./js/app/generic/generic.dropdown.js
 ** module id = 4
 ** module chunks = 24
 **/